import PhygitalNFTAbi    from "./PhygitalNFT.abi.json";
import NFTMarketplaceAbi from "./NFTMarketplace.abi.json";
import addresses         from "./addresses.json";

const env = (import.meta as any).env ?? {};
export { PhygitalNFTAbi, NFTMarketplaceAbi, addresses };
export const NFT_ADDRESS         = (env.VITE_NFT_ADDRESS         as string) || (addresses as any).PhygitalNFT    || "";
export const MARKETPLACE_ADDRESS = (env.VITE_MARKETPLACE_ADDRESS as string) || (addresses as any).NFTMarketplace || "";
export const DEPLOYED_CHAIN_ID: number = (addresses as any).chainId ?? 137;
